/*
  Millie & Jones: ratings and reviews for the bed page's extras (v21, 16 Oct 2026).

  snippets/mj-bed-addons.liquid gives an extra with enough Judge.me reviews (Professional Assembly: 31) its stars
  and "31 reviews" on its tick row, and a Reviews tab in its pop-up next to "What's included". This file:
    - opens the pop-up on the right tab: the stars open Reviews, "What's included" opens its own tab. The page
      itself opens on "What's included", so that tab still works if this file fails to load;
    - fetches the reviews the first time Reviews is shown. Judge.me keeps them on the extra's product
      (judgeme.review_widget_ssr_html) and sections/mj-addon-reviews.liquid hands them over for the extras this
      bed offers (the bed's address with ?section_id=mj-addon-reviews), so the bed page doesn't carry them;
    - lists every review, newest first, five to start with and "Show all" for the rest. A bar of the star
      breakdown shows only that rating. Nothing is held back: 1-star reviews list like any other. If Judge.me's
      copy ever holds fewer reviews than its count, the list says "Latest X of N" and the breakdown keeps
      Judge.me's own numbers, so the page never claims more than it shows;
    - shows names as first name and initial (Kathleen R.), dates in UK time (12 Sep 2026), and our replies;
    - the button at the bottom ticks the extra's own row, so assets/mj-bed.js updates the totals and tracking
      as for a tap on the row. Tapped, the pop-up then closes; from the keyboard it stays open on "Added".
  Opening and closing pop-ups, the backdrop and the focus stay with assets/mj-bed.js ([data-mjb-open-dialog]).
*/
(function () {
  'use strict';
  if (window.__mjAddonReviews) return;
  window.__mjAddonReviews = true;

  var SECTION = 'mj-addon-reviews';
  var FIRST = 5;
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var TITLES = /^(mr|mrs|ms|miss|mx|dr)\.?$/i;
  var STARS = '★★★★★';

  /* ---------- Fetch once per page (and again after a failure) ---------- */
  var requests = {};
  function sectionUrl(dialog) {
    var base = dialog.getAttribute('data-mjb-reviews-url') || window.location.pathname;
    try {
      var url = new URL(base, window.location.origin);
      url.search = '';
      url.hash = '';
      url.searchParams.set('section_id', SECTION);
      return url.toString();
    } catch (error) {
      return null;
    }
  }
  function load(dialog) {
    var url = sectionUrl(dialog);
    if (!url) return Promise.resolve(null);
    if (requests[url]) return requests[url];
    requests[url] = fetch(url, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(function (response) {
        if (!response.ok) throw new Error('reviews ' + response.status);
        return response.text();
      })
      .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); })
      .catch(function () {
        delete requests[url]; // the next try fetches again
        return null;
      });
    return requests[url];
  }
  function forget(dialog) {
    var url = sectionUrl(dialog);
    if (url) delete requests[url];
  }

  /* ---------- Reading Judge.me's review HTML ---------- */
  function clean(text) {
    return String(text || '')
      .split('\n')
      .map(function (line) { return line.replace(/\s+/g, ' ').trim(); })
      .filter(Boolean)
      .join('\n');
  }

  function blockText(el) {
    if (!el) return '';
    var copy = el.cloneNode(true);
    Array.prototype.forEach.call(copy.querySelectorAll('br'), function (br) { br.replaceWith('\n'); });
    var paras = copy.querySelectorAll('p');
    var text = paras.length
      ? Array.prototype.map.call(paras, function (p) { return p.textContent; }).join('\n')
      : copy.textContent;
    return clean(text);
  }

  function shortName(name) {
    var words = String(name || '').trim().split(/\s+/).filter(Boolean);
    if (!words.length) return 'Customer';
    if (words.length > 2 && TITLES.test(words[0])) words.shift();
    var cap = function (w) { return w.charAt(0).toUpperCase() + w.slice(1); };
    if (words.length === 1) return cap(words[0]);
    return cap(words[0]) + ' ' + words[words.length - 1].charAt(0).toUpperCase() + '.';
  }

  function ukDate(date) {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', day: 'numeric', month: 'numeric', year: 'numeric' }).formatToParts(date);
      var get = function (type) {
        for (var i = 0; i < parts.length; i++) if (parts[i].type === type) return parts[i].value;
        return '';
      };
      return Number(get('day')) + ' ' + MONTHS[Number(get('month')) - 1] + ' ' + get('year');
    } catch (error) {
      return date.getUTCDate() + ' ' + MONTHS[date.getUTCMonth()] + ' ' + date.getUTCFullYear();
    }
  }

  function parse(doc, productId) {
    if (!doc || !productId) return null;
    var template = doc.querySelector('template[data-mj-addon-reviews="' + productId + '"]');
    if (!template) return null;
    var reviews = [];
    Array.prototype.forEach.call(template.content.querySelectorAll('.jdgm-rev'), function (el) {
      var ratingEl = el.querySelector('.jdgm-rev__rating');
      var rating = parseInt(ratingEl && ratingEl.getAttribute('data-score'), 10);
      if (!(rating >= 1 && rating <= 5)) return;
      var timeEl = el.querySelector('.jdgm-rev__timestamp');
      var stamp = timeEl ? (timeEl.getAttribute('datetime') || String(timeEl.getAttribute('data-content') || '').replace(' UTC', 'Z').replace(' ', 'T')) : '';
      var when = stamp ? new Date(stamp) : null;
      var ok = when && !isNaN(when.getTime());
      var authorEl = el.querySelector('.jdgm-rev__author');
      var titleEl = el.querySelector('.jdgm-rev__title');
      var reply = blockText(el.querySelector('.jdgm-rev__reply')).replace(/^[^\n]{0,60}\breplied:?\s*/i, '');
      // A rating with no words still counts and still lists, so the list always matches the breakdown
      reviews.push({
        rating: rating,
        time: ok ? when.getTime() : 0,
        date: ok ? ukDate(when) : '',
        name: shortName(authorEl ? authorEl.textContent : ''),
        title: clean(titleEl ? titleEl.textContent : ''),
        body: blockText(el.querySelector('.jdgm-rev__body')),
        reply: reply,
      });
    });
    reviews.sort(function (a, b) { return b.time - a.time; });
    return reviews;
  }

  /* ---------- Showing them ---------- */
  function q(root, selector) { return root.querySelector(selector); }
  function qa(root, selector) { return Array.prototype.slice.call(root.querySelectorAll(selector)); }
  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function stars(rating) {
    var wrap = el('span', 'mjb-stars mjb-rev__stars');
    wrap.setAttribute('role', 'img');
    wrap.setAttribute('aria-label', rating + ' out of 5 stars');
    var base = el('span', 'mjb-stars__base', STARS);
    base.setAttribute('aria-hidden', 'true');
    var fill = el('span', 'mjb-stars__fill', STARS);
    fill.setAttribute('aria-hidden', 'true');
    fill.style.width = (rating * 20) + '%';
    wrap.appendChild(base);
    wrap.appendChild(fill);
    return wrap;
  }

  function item(review) {
    var li = el('li', 'mjb-rev');
    li.tabIndex = -1; // "Show all" moves focus to the first new review
    var head = el('div', 'mjb-rev__head');
    head.appendChild(stars(review.rating));
    if (review.date) head.appendChild(el('span', 'mjb-rev__date', review.date));
    li.appendChild(head);
    if (review.title) li.appendChild(el('p', 'mjb-rev__title', review.title));
    if (review.body) li.appendChild(el('p', 'mjb-rev__body', review.body));
    li.appendChild(el('p', 'mjb-rev__name', review.name));
    if (review.reply) {
      var reply = el('div', 'mjb-rev__reply');
      reply.appendChild(el('p', 'mjb-rev__reply-by', 'Reply from Millie & Jones'));
      reply.appendChild(el('p', 'mjb-rev__reply-text', review.reply));
      li.appendChild(reply);
    }
    return li;
  }

  function stateOf(dialog) {
    if (!dialog._mjRevs) {
      dialog._mjRevs = { reviews: null, filter: 0, all: false, complete: true, expected: Number(dialog.getAttribute('data-mjb-reviews-count')) || 0 };
    }
    return dialog._mjRevs;
  }

  // With every review in hand, the breakdown comes from them, so the bars and the list always agree.
  // Otherwise the server's Judge.me numbers stay and only the bars with loaded reviews can filter.
  function updateBars(dialog) {
    var st = stateOf(dialog);
    var total = st.reviews.length;
    qa(dialog, '[data-mjb-revs-bar]').forEach(function (bar) {
      var n = Number(bar.getAttribute('data-mjb-revs-bar'));
      var count = st.reviews.filter(function (r) { return r.rating === n; }).length;
      if (st.complete) {
        var countEl = q(bar, '[data-mjb-revs-count]');
        var fill = q(bar, '[data-mjb-revs-fill]');
        if (countEl) countEl.textContent = String(count);
        if (fill) fill.style.width = (total ? Math.round((count / total) * 100) : 0) + '%';
      }
      bar.disabled = count === 0;
    });
  }

  function render(dialog) {
    var st = stateOf(dialog);
    if (!st.reviews) return;
    var pool = st.filter ? st.reviews.filter(function (r) { return r.rating === st.filter; }) : st.reviews;
    var shown = st.filter || st.all ? pool : pool.slice(0, FIRST);
    var list = q(dialog, '[data-mjb-revs-list]');
    if (list) {
      list.textContent = '';
      shown.forEach(function (review) { list.appendChild(item(review)); });
    }
    var heading = q(dialog, '[data-mjb-revs-heading]');
    if (heading) {
      if (st.filter) heading.textContent = st.filter + '-star ' + (pool.length === 1 ? 'review' : 'reviews') + ' (' + pool.length + ')';
      else if (st.complete) heading.textContent = 'All ' + st.reviews.length + ' reviews';
      else heading.textContent = 'Latest ' + st.reviews.length + ' of ' + st.expected + ' reviews';
    }
    var more = q(dialog, '[data-mjb-revs-more]');
    if (more) {
      more.hidden = !!st.filter || st.all || pool.length <= FIRST;
      more.textContent = st.complete ? 'Show all ' + pool.length + ' reviews' : 'Show ' + (pool.length - FIRST) + ' more';
    }
    var note = q(dialog, '[data-mjb-revs-note]');
    if (note && !st.complete) {
      note.textContent = 'Showing the latest ' + st.reviews.length + ' of ' + st.expected + ' reviews, newest first. Reviews are collected through Judge.me and Trustpilot.';
    }
    var clear = q(dialog, '[data-mjb-revs-clear]');
    if (clear) clear.hidden = !st.filter;
    qa(dialog, '[data-mjb-revs-bar]').forEach(function (bar) {
      var on = Number(bar.getAttribute('data-mjb-revs-bar')) === st.filter;
      bar.setAttribute('aria-pressed', String(on));
      bar.classList.toggle('is-on', on);
    });
    var status = q(dialog, '[data-mjb-revs-status]');
    if (status) status.hidden = true;
    var retry = q(dialog, '[data-mjb-revs-retry]');
    if (retry) retry.hidden = true;
  }

  function ensure(dialog) {
    var st = stateOf(dialog);
    if (st.reviews) {
      render(dialog);
      return Promise.resolve(true);
    }
    var status = q(dialog, '[data-mjb-revs-status]');
    var retry = q(dialog, '[data-mjb-revs-retry]');
    if (status) {
      status.hidden = false;
      status.textContent = 'Loading reviews…';
    }
    if (retry) retry.hidden = true;
    return load(dialog).then(function (doc) {
      var reviews = parse(doc, dialog.getAttribute('data-mjb-reviews'));
      if (!reviews || !reviews.length) {
        forget(dialog); // a page that came back without them: ask again next time
        if (status) status.textContent = "The reviews didn't load.";
        if (retry) retry.hidden = false;
        return false;
      }
      st.reviews = reviews;
      st.complete = !st.expected || reviews.length >= st.expected;
      updateBars(dialog);
      render(dialog);
      return true;
    });
  }

  /* ---------- Tabs (Reviews / What's included) ---------- */
  function selectTab(dialog, name) {
    var tabs = qa(dialog, '[data-mjb-dtab]');
    if (tabs.length) {
      if (!tabs.some(function (t) { return t.getAttribute('data-mjb-dtab') === name; })) name = tabs[0].getAttribute('data-mjb-dtab');
      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-mjb-dtab') === name;
        tab.setAttribute('aria-selected', String(on));
        tab.tabIndex = on ? 0 : -1;
      });
      qa(dialog, '[data-mjb-dpanel]').forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-mjb-dpanel') !== name;
      });
    }
    var panel = q(dialog, '[data-mjb-dpanel="' + name + '"]');
    if (panel) panel.scrollTop = 0;
    if (name === 'reviews' || !tabs.length) ensure(dialog);
  }

  /* ---------- The Add button: ticks the extra's own row ---------- */
  function rowInput(dialog) {
    var id = dialog.getAttribute('data-mjb-row');
    return id ? document.getElementById(id) : null;
  }

  function syncFoot(dialog) {
    var foot = q(dialog, '[data-mjb-revs-foot]');
    if (!foot) return;
    var input = rowInput(dialog);
    var row = input ? input.closest('[data-mjb-opt]') : null;
    var usable = !!(input && row && !input.disabled && !row.hidden && row.getClientRects().length);
    foot.hidden = !usable;
    if (!usable) return;
    var price = q(row, '[data-mjb-opt-price]');
    var priceOut = q(foot, '[data-mjb-revs-price]');
    if (price && priceOut) priceOut.textContent = price.textContent.trim();
    var add = q(foot, '[data-mjb-revs-add]');
    var added = q(foot, '[data-mjb-revs-added]');
    if (add) add.hidden = input.checked;
    if (added) added.hidden = !input.checked;
  }

  function say(dialog, text) {
    var live = q(dialog, '[data-mjb-revs-live]');
    if (!live) return;
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 50);
  }

  function smooth() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  }

  /* ---------- Events ---------- */
  // Openers on the row: pick the tab before assets/mj-bed.js opens the pop-up (capture runs first)
  document.addEventListener('click', function (event) {
    var opener = event.target.closest ? event.target.closest('[data-mjb-dialog-tab]') : null;
    if (!opener) return;
    var dialog = document.getElementById(opener.getAttribute('data-mjb-open-dialog') || '');
    if (!dialog || !dialog.hasAttribute('data-mjb-reviews')) return;
    clearTimeout(dialog._mjRevsTimer);
    var st = stateOf(dialog);
    st.filter = 0;
    st.all = false;
    selectTab(dialog, opener.getAttribute('data-mjb-dialog-tab'));
    syncFoot(dialog);
  }, true);

  // Start the request as the finger lands on the stars
  document.addEventListener('pointerdown', function (event) {
    var opener = event.target.closest ? event.target.closest('[data-mjb-dialog-tab="reviews"]') : null;
    if (!opener) return;
    var dialog = document.getElementById(opener.getAttribute('data-mjb-open-dialog') || '');
    if (dialog && dialog.hasAttribute('data-mjb-reviews')) load(dialog);
  }, { capture: true, passive: true });

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target.closest) return;
    var dialog = target.closest('dialog[data-mjb-reviews]');
    if (!dialog) return;

    var tab = target.closest('[data-mjb-dtab]');
    if (tab) {
      selectTab(dialog, tab.getAttribute('data-mjb-dtab'));
      return;
    }
    var go = target.closest('[data-mjb-dgo]');
    if (go) {
      var name = go.getAttribute('data-mjb-dgo');
      selectTab(dialog, name);
      var goTab = q(dialog, '[data-mjb-dtab="' + name + '"]');
      if (goTab) goTab.focus();
      return;
    }
    var st = stateOf(dialog);
    var bar = target.closest('[data-mjb-revs-bar]');
    if (bar) {
      var n = Number(bar.getAttribute('data-mjb-revs-bar'));
      ensure(dialog).then(function (ok) {
        if (!ok) return;
        st.filter = st.filter === n ? 0 : n;
        render(dialog);
        // bring the list up, so the tap visibly does something
        var panel = q(dialog, '[data-mjb-dpanel="reviews"]');
        var head = q(dialog, '.mjb-revs__listhead');
        if (panel && head) {
          var top = head.getBoundingClientRect().top - panel.getBoundingClientRect().top;
          if (top > panel.clientHeight * 0.6) panel.scrollTo({ top: panel.scrollTop + top - 12, behavior: smooth() });
        }
      });
      return;
    }
    if (target.closest('[data-mjb-revs-clear]')) {
      st.filter = 0;
      render(dialog);
      var firstBar = q(dialog, '[data-mjb-revs-bar]:not([disabled])');
      if (firstBar) firstBar.focus();
      return;
    }
    if (target.closest('[data-mjb-revs-more]')) {
      st.all = true;
      render(dialog);
      var next = qa(dialog, '[data-mjb-revs-list] > li')[FIRST];
      if (next) next.focus({ preventScroll: false });
      return;
    }
    if (target.closest('[data-mjb-revs-retry]')) {
      ensure(dialog);
      return;
    }
    if (target.closest('[data-mjb-revs-add]')) {
      var input = rowInput(dialog);
      if (input && !input.checked && !input.disabled) input.click();
      syncFoot(dialog);
      var title = q(dialog, '.mjb-modal__title');
      say(dialog, (title ? title.textContent.trim() + ' a' : 'A') + 'dded to your bed');
      var done = q(dialog, '[data-mjb-revs-added]');
      if (done && !done.hidden) {
        var remove = q(done, '[data-mjb-revs-remove]');
        if (remove) remove.focus({ preventScroll: true });
      }
      clearTimeout(dialog._mjRevsTimer);
      // A tap closes it after a moment; from the keyboard (detail 0) it stays open, so Remove can be reached
      if (event.detail > 0) dialog._mjRevsTimer = setTimeout(function () { if (dialog.open) dialog.close(); }, 1000);
      return;
    }
    if (target.closest('[data-mjb-revs-remove]')) {
      clearTimeout(dialog._mjRevsTimer);
      var checked = rowInput(dialog);
      if (checked && checked.checked) checked.click();
      syncFoot(dialog);
      say(dialog, 'Removed');
      var addAgain = q(dialog, '[data-mjb-revs-add]');
      if (addAgain && !addAgain.hidden) addAgain.focus({ preventScroll: true });
    }
  });

  // Arrow keys move between the tabs
  document.addEventListener('keydown', function (event) {
    var tab = event.target.closest ? event.target.closest('[data-mjb-dtab]') : null;
    if (!tab) return;
    var keys = ['ArrowRight', 'ArrowLeft', 'Home', 'End'];
    if (keys.indexOf(event.key) === -1) return;
    var dialog = tab.closest('dialog');
    var tabs = qa(tab.parentElement, '[data-mjb-dtab]');
    var i = tabs.indexOf(tab);
    var next = event.key === 'Home' ? 0
      : event.key === 'End' ? tabs.length - 1
      : (i + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    event.preventDefault();
    selectTab(dialog, tabs[next].getAttribute('data-mjb-dtab'));
    tabs[next].focus();
  });

  // Closed by hand before it closed itself: nothing left to do
  document.addEventListener('close', function (event) {
    var dialog = event.target;
    if (dialog && dialog._mjRevsTimer) clearTimeout(dialog._mjRevsTimer);
  }, true);
})();
